/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AboutInputs */

const en_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const es_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fr_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const de_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über`)
};

const ja_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アバウト`)
};

const zh_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const ar_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبذة عنا`)
};

const id_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang`)
};

const it_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi Siamo`)
};

const ru_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас`)
};

const pt_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const ko_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소개`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {AboutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const about = /** @type {((inputs?: AboutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AboutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about(inputs)
	if (locale === "es") return es_about(inputs)
	if (locale === "fr") return fr_about(inputs)
	if (locale === "de") return de_about(inputs)
	if (locale === "ja") return ja_about(inputs)
	if (locale === "zh") return zh_about(inputs)
	if (locale === "ar") return ar_about(inputs)
	if (locale === "id") return id_about(inputs)
	if (locale === "it") return it_about(inputs)
	if (locale === "ru") return ru_about(inputs)
	if (locale === "pt") return pt_about(inputs)
	return ko_about(inputs)
});